<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">

         <div class="lg:mb-4 mt-4" v-if="form.Guid">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.guid')}}
                <el-form-item prop="Guid">
                  <el-input
                    disabled
                    class="w-full"
                    v-model="form.Guid"
                    maxlength='100'
                  />
                </el-form-item>
              </label>
            </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('saml2.ruta')}}
                <el-form-item prop="Ruta">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Ruta"
                    maxlength='500'
                  />
                </el-form-item>
              </label>
            </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('saml2.issuer')}}
                <el-form-item prop="Issuer">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Issuer"
                    maxlength='500'
                  />
                </el-form-item>
              </label>
            </div>
          </div>

          <!-- <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('saml2.cert')}}
                <el-form-item prop="Cert">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Cert"
                    maxlength='500'
                    type="textarea"
                    :rows="8"
                  />
                </el-form-item>
              </label>
            </div>
          </div> -->

          <div class="flex -mx-2 flex-col lg:flex-row">
            <div class="px-2  mb-2 lg:mb-0">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('saml2.cert')}}</label>
                <el-form-item prop="file" ref="uploadpfxref">
                  <Upload
                    role="button"
                    ref="upload"
                    accept=".cer,.pem"
                    id="pfxselector"
                    class="bg-white dark:bg-darkblue-900 "
                    :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                    drag
                    action="#"
                    :show-file-list="false"
                    :multiple="false"
                    :auto-upload=false
                    :on-remove="handleRemove"
                    :on-change="handleChange">
                    <i class="el-icon-upload"></i>
                    <p v-if="file.name" class="el-upload__text"><em>{{file.name}}</em></p>
                    <div v-else class="el-upload__text">Suelta tu archivo aquí o <em>haz clic para cargar</em></div>
                  </Upload>
                </el-form-item>
            </div>
          </div>

          <div class="lg:mb-2" v-if="form.FechaCaducidadCert">
            <div>
              <base-ro-input-minimal :label="$t('certificates.expires_at')" :data="form.FechaCaducidadCert" />
            </div>
          </div>

        </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.cancel')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive 
            mode="primary" 
            :text="$t('app.save')" 
            icon="save" 
            @click="submitForm('ruleForm')" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import moment from 'moment'
import DetailLayout from '../../components/layout/DetailLayout.vue'
import { getClient } from '@/services/clients/getClient'
import { getconfigsaml2 } from '@/services/clients/getconfigsaml2'
import { updateconfigsaml2 } from '@/services/clients/updateconfigsaml2'
import { i18n } from '@/i18n'
import { Upload } from 'element-ui'

export default {
  /* eslint-disable camelcase */
  name: 'config-saml2-detail',
  components: {
    DetailLayout,
    Upload,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('clients.config_saml2'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/clients/details'
      },
      form: {
        Guid: '',
        Ruta: '',
        Issuer: '',
        FechaCaducidadCert: '',
        // Cert: '',
      },
      file: {
        name: '',
        b64: ''
      },
      rules: {
        Ruta: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        Issuer: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        Cert: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        file: [
          {
            message: this.$i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.file.name) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
              } else {
                callback()
              }
            }
          },
        ]
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    id () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : -1
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: async function () {
    const breadcrumbs = []
    breadcrumbs.push({
      path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
      name: this.$i18n.t('app.configurations')
    })
    breadcrumbs.push({
      path: 'configurations/clients',
      name: this.$i18n.t('app.clients')
    })
    if (this.id !== -1) {
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const cliente = await this.downloadClientData(this.id)
        breadcrumbs.push({ path: '', name: cliente.empresa.Nombre })
        this.$store.commit('app/setheaderBreadCrumb', cliente.empresa.Nombre)
      }
    }
    this.header.breadcrumb = breadcrumbs

    const data = await this.downloadData(this.id)
    this.setData(data.respuesta)
  },
  mounted () {
    this.resetControlFormChanges()
  },
  methods: {
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idEmpresa: id
        }
        client = await getClient(params)
        if (client.blnError === true) {
          this.doFeedback(client.msgError + ' [Código de error: ' + client.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    handleChange: function (file) {
      this.$refs.uploadpfxref.clearValidate()
      this.file.name = file.name
      this.getBase64(file.raw).then(res => {
        const b64 = res.split(',')
        this.file.b64 = b64[1]
      })
    },
    handleRemove: function () {
      this.file.name = null
      this.file.b64 = null
    },
    submitForm: async function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            const payload = {
              idCliente: this.id,
              Ruta: this.form.Ruta,
              Issuer: this.form.Issuer,
              Cert: this.file.b64,
            }
            const response = await updateconfigsaml2(null, payload)
            if (response.blnError === true) {
              this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
            } else {
              this.doFeedback('Datos actualizados correctamente', 'success')
              const data = await this.downloadData(this.id)
              this.setData(data.respuesta)
              this.resetControlFormChanges()
            }
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
          this.$store.commit('setIsLoading', false)
        })
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/clients/details', params: this.id })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const data = await getconfigsaml2({ idCliente: id })
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          return data
        }
        return data
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setData: function (data) {
      if (data) {
        this.form.Guid = data.Guid ? data.Guid : null
        this.form.Ruta = data.Ruta ? data.Ruta : null
        this.form.Issuer = data.Issuer ? data.Issuer : null
        // this.form.Cert = data.Cert ? data.Cert : null
        this.file.b64 = data.Cert ? data.Cert : null
        this.file.name = data.Cert ? 'Certificado cargado' : null 
        this.form.FechaCaducidadCert = data.FechaCaducidadCert ? moment(data.FechaCaducidadCert).format('DD-MM-yyyy HH:mm') : null
      }
      this.resetControlFormChanges()
    },
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

</style>

<style lang="sass" scoped>
</style>
